/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createConj } from '../../factoriesAny.js';
export var conjDependencies = {
  typedDependencies: typedDependencies,
  createConj: createConj
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesConj.generated.js
// module id = 227
// module chunks = 0